import moment from "moment-timezone";
import type { DateFiltersMode, DateFiltersState } from "../types";

export const modes: DateFiltersMode[] = ["day", "week", "month", "custom", "pay-group"];

export const initialState: DateFiltersState = {
    from: moment().startOf("day").format("YYYY-MM-DD"),
    to: moment().startOf("day").format("YYYY-MM-DD"),
    mode: "day",
    payGroupCode: undefined,
    payGroupId: undefined,
    payGroupPeriod: undefined,
    dispatch: () => null,
    modes
};
